import { CentroidSettingsQuery } from '../types'
import { OperationType } from 'features/analysis/types'
import { buildAnalysisQueryFromSource, getQFromQuery } from '../../utils'

export function generateQuery(payload: CentroidSettingsQuery) {
  const { mainSource, aggregationOperation, aggregationField, categorizeBy } = payload
  const baseQuery = buildAnalysisQueryFromSource({ source: mainSource })
  const geomField = mainSource.geoColumn || mainSource.metadata?.schema?.find((c) => c.type === 'geometry')?.name
  const ctes: Array<string> = []

  let centroidFunction = `ST_CENTROID(${geomField}) AS geom`
  let columns = mainSource.metadata?.schema?.filter((c) => c.type !== 'geometry')
  let cteCount = getQFromQuery(baseQuery) || 1

  if (categorizeBy || aggregationOperation) {
    // Approximate centroid: weighted average based on the dimension of the geometry
    // This is needed because ST_COLLECT(geom) is not compatible with ST_INTERSECTS
    // used in dynamic tiling. This is a known limitation of Redshift.
    const query = `SELECT\n\t\t*,\n\t\tST_CENTROID(geom) AS __point,\n\t\t(0.00001 + ST_LENGTH(geom) + ST_AREA(geom)) AS __weight\n\tFROM\n\t\t__q${cteCount}`
    cteCount += 1
    ctes.push(`__q${cteCount} AS (\n\t${query}\n)`)
    centroidFunction = `ST_POINT(\n\t\t\tSUM(ST_X(__point)*__weight) / SUM(__weight),\n\t\t\tSUM(ST_Y(__point)*__weight) / SUM(__weight)\n\t\t) AS geom`
  }

  let categorization = ''
  if (categorizeBy) {
    categorization = `\n\tGROUP BY\n\t\t${categorizeBy}`
    columns = [{ name: categorizeBy, type: 'string' }]
  }

  if (aggregationOperation) {
    columns = []
    columns.push({ name: generateOperation(aggregationOperation, aggregationField), type: 'number' })
    if (categorizeBy) {
      columns.push({ name: categorizeBy, type: 'string' })
    }
  }

  const query = `SELECT\n\t\t${centroidFunction}${columns?.length ? ',' : ''}${columns.map(
    (c) => `\n\t\t${c.name}`
  )}\n\tFROM\n\t\t__q${cteCount}${categorization}`
  cteCount += 1
  ctes.push(`__q${cteCount} AS (\n\t${query}\n)`)

  return `${baseQuery},\n${ctes.join(',\n')}\nSELECT * FROM __q${cteCount}`
}

export function generateOperation(operation: OperationType, column?: string) {
  switch (operation) {
    case OperationType.COUNT:
      return 'COUNT(*) AS aggregated_count'
    case OperationType.AVG:
    case OperationType.SUM:
    case OperationType.MAX:
    case OperationType.MIN:
      return `${operation}(${column}) AS aggregated_${operation}`
  }
}
